import React from 'react';
import { Button } from './Button';
import type { LandingActions } from '../types/actions';
export function StickyMobileCTA({
  onFormCta
}: Pick<LandingActions, 'onFormCta'>) {
  return <div className="fixed inset-x-0 bottom-0 z-40 border-t border-line bg-white/95 px-3 py-2.5 backdrop-blur-md md:hidden" data-id="element-169" data-mp="1orpzrpv9764c">
      <Button size="md" onClick={() => onFormCta('sticky_bar')} fullWidth data-id="element-170" data-mp="1tpi1fblpa6lq">
        See How NEXT Helps
      </Button>
    </div>;
}